import React from "react";
import { Create } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import { SubscriptionForm } from "./SubscriptionForm";
import { useNotification } from "../../../common/hooks/useNotification";

interface ISubscriptionCreateProps {}

export const SubscriptionCreate = (props: ISubscriptionCreateProps) => {
  const notify = useNotification(props, "createSuccess");
  return (
    <Create
      {...props}
      actions={<EditActions />}
      onSuccess={notify}
      title="resources.master-subscriptions.title.create">
      <SubscriptionForm />
    </Create>
  );
};
